import BlogTwentyContainer from "./container/BlogTwentyContainer";
export default BlogTwentyContainer;
